import { memo } from 'react';
import {
  Avatar, Card, Grid, Stack,
  Typography,
} from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useIsMobile } from '@client/hooks/dom.hooks';
import Testimonial3 from './testimonial-3.png';

const useStyles = makeStyles()((theme) => ({
  root: {
    padding: theme.spacing(3),
    backgroundColor: theme.palette.warning.xlight,
    borderRadius: theme.radii.large,
  },
  image: {
    height: 50,
    width: 50,

    [theme.breakpoints.up('md')]: {
      height: 154,
      width: 154,
    },
  },
}));

export const PayoutInfo = memo(() => {
  const { classes } = useStyles();
  const isMobile = useIsMobile();

  return (
    <Card className={classes.root}>
      <Grid
        container
        spacing={3}
        alignItems="center"
        wrap="nowrap"
      >
        {!isMobile && (
          <Grid item>
            <Avatar
              className={classes.image}
              src={Testimonial3}
              alt="Gully Boys"
            />
          </Grid>
        )}

        <Grid item>
          <Stack spacing={isMobile ? 2 : 1}>
            <Typography
              variant="h6"
              color="textSecondary"
            >
              To date, Side Door artists have earned more than $1.6M.
            </Typography>
          </Stack>
        </Grid>
      </Grid>
    </Card>
  );
});
